import router from "@/router";
import store from "@/store";
import axios from "axios";
import message from "ant-design-vue/es/message";
import notification from "ant-design-vue/es/notification";
import {Modal} from "ant-design-vue";
import global from "@/globalval/globalval";
import {
	getSm4Response,
	setSM4Key
} from "@/utils/sm2and4/smkey.js";

const baseUrl = global.fileBaseUrl;

/**
 * SM4 公钥
 */
const sm4PubKeyMap = new Map();
/**
 * 获取加密数据
 */
const getSm4DataList = [
/*
    baseUrl + "/api/ggfw-affair-base-center/affair/case/param/query",
    baseUrl + "/api/ggfw-affair-base-center/affair/case/process/load",
*/

    baseUrl + "/api/ggfw-background-user-center/bguser/getLoginuser",
];

/**
 * 需要加密的请求
 * @type {string[]}
 */
const sm4WhiteList = [
/*
    baseUrl + "/api/ggfw-affair-base-center/affair/case/param/query",
    baseUrl + "/api/ggfw-affair-base-center/affair/case/process/load",
    baseUrl + "/api/ggfw-affair-base-center/affair/case/create/businesscase",
    baseUrl + "/api/ggfw-affair-base-center/affair/case/cache",
    baseUrl + "/api/ggfw-affair-base-center/affair/case/commbusiness/complete",
*/

    baseUrl + "/api/ggfw-background-user-center/bguser/getLoginuser",
    baseUrl + "/api/ggfw-background-user-center/bguser/changePassword",
    baseUrl + "/api/api/auth/bguser/passwordLogin",
    baseUrl + "/api/api/auth/bguser/sicardLogin",
];

// 创建 axios 实例
const service = axios.create({
    timeout: 60000,
});
var flag=true;
// 请求拦截器
service.interceptors.request.use(config => {
	// 带上公共token
	//config.headers.common['Access-Token'] = 'd26910f2-6d7d-49d0-889a-4a33e94278a5';

	/*config.headers.common['Access-Token'] = store.getters.token;
	config.headers.common["channel-type"] = "JSHRSS_PORTAL";
	if (sm4WhiteList.includes(config.url) && (global.smSwitch=='true')) {
		let sm4data = setSM4Key(config.data);
		config.data = sm4data.cipher;
		let sm4PublicKey = sm4data.sm4PublicKey;
		sm4PubKeyMap.set(config.url, sm4PublicKey);
	}*/
    config.headers.common['Access-Token'] = store.getters.token;
	return config;
}, error => {
	return Promise.reject(error)
})

// 请求响应后处理
service.interceptors.response.use(
    (response) => {
        mockResponseHandle(response);

        /**/

        if (response.status === 200) {
            // 成功返回
            if (response.data && response.data.appcode == "02010500") {
                if(flag){
                    flag= false;
                    Modal.confirm({
                        title: '提示',
                        okText: '去登录',
                        content: '你长时间未操作或在其它地方登录，请重新登录',
                        onOk: () => {
                            flag= true;
                            store.dispatch("user/logout").then((response) => {
                                router.push({ path: "/login" });
                            });
                        },
                        onCancel() {
                            flag= true;
                        },
                    })
                }
            }

			if (getSm4DataList.includes(response.config.url) && (global.smSwitch=='true')) {
				let encrytData = response.data.encryptData;
				let sm4Pub = sm4PubKeyMap.get(response.config.url);
				response.data = getSm4Response(sm4Pub, sm4Pub, encrytData);
			}
            return Promise.resolve(response.data);
        }
        // 错误处理
        responseErrorHandle(response);
        return Promise.reject(response);
    },
    (error) => {
        if (error.response&&error.response.status === 401) {
            if(flag){
                flag= false;
                Modal.confirm({
                    title: '提示',
                    okText: '去登录',
                    content: '你长时间未操作或在其它地方登录，请重新登录',
                    onOk: () => {
                        flag= true;
                        store.dispatch("user/logout").then((response) => {
                            router.push({ path: "/login" });
                        });
                    },
                    onCancel() {
                        flag= true;
                    },
                })
            }

        }else{
            if (error.response&&error.response.data) {
                return Promise.resolve(error.response.data);
            } else {
                if(error&&error.response){
                    responseErrorHandle(error.response);
                    return Promise.reject(error.response);
                }else{
                    //responseErrorHandle("请求超时,请检查网络!");
                    return Promise.reject("请求超时,请检查网络!");
                }

            }
        }

    }
);

// 全局处理非200异常
const responseErrorHandle = function(response) {
    if (response && response.status) {
        // 根据状态码 全局处理 TO_DO
        message.error(response.status);
    } else {
        message.error("服务正在维护, 请稍后重试!");
    }
};

/**
 * mock请求处理
 * @param {Object} response
 */
const mockResponseHandle = function(response) {
    if (response && response.data && response.data._isMock) {
        notification.warning({
            message: "MOCK请求",
            description: response.config.url,
            placement: "bottomRight",
        });
    }
};

export default service;
